export enum FilterByType {
  APPLICATIONS = 'FILTER_BY_APPlICATIONS',
  MERCHANTS = 'FILTER_BY_TYPE_MERCHANTS',
  CHECKOUT_SESSIONS = 'FILTER_BY_TYPE_CHECKOUT_SESSIONS',
  // AGENTS = 'AGENTS',
}
